export default __webpack_public_path__ + "static/media/flag.6f6e5709.svg";